"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Chip;
const core_1 = require("@material-ui/core");
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importDefault(require("react"));
const variables_1 = __importDefault(require("../../styles/variables"));
const useStyles = (0, core_1.makeStyles)({
    chip: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '6px 1px 6px 1px',
        gap: '4px',
        position: 'absolute',
        background: variables_1.default.colors.surface.neutral.default,
        borderRadius: '20px',
    },
    label: {
        fontFamily: variables_1.default.fonts.family.heading,
        fontWeight: variables_1.default.fonts.weight.medium,
        fontSize: variables_1.default.fonts.size.regular,
        paddingLeft: '5px',
        paddingRight: '5px',
        lineHeight: variables_1.default.fonts.lineHeight.regular,
        letterSpacing: variables_1.default.fonts.letterSpacing.regular,
        color: variables_1.default.colors.base.text,
    },
});
function Chip({ key, label, variant, onClick, onDelete, ...props }) {
    const classes = useStyles({});
    return (react_1.default.createElement(core_1.Chip, { key: key, label: label, classes: {
            label: classes.label,
            root: (0, clsx_1.default)([classes.chip]),
        }, variant: variant, onClick: (e) => onClick && onClick(e), onDelete: (e) => onDelete && onDelete(e), ...props }));
}
